const getEnv = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[key]
  if (!value && defaultValue === undefined) {
    return ''
  }
  return value || defaultValue!
}

export const authConfig = Object.freeze({
  google: {
    clientId: getEnv('VITE_GOOGLE_CLIENT_ID', ''),
  },
  apple: {
    clientId: 'com.grndhouse.web',
  },
})
